<template>
  <div class="row">
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Agregar Fecha (Rondas)</h3>
        </div>
        <div class="panel-body">
          <div class="form-group">
            <label>Fecha</label>
            <datepicker :value.sync="date.date" format="dd/MM/yyyy"></datepicker>
          </div>
          <div class="form-group">
            <button type="button" class="btn btn-default" @click="addDate">Agregar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Rondas de juego</h3>
        </div>
        <div class="panel-body">
          <table class="table table-bordered table-condensed">
            <tr>
              <th>Fecha</th>
              <th>Acción</th>
            </tr>
            <tr v-for="date in dates">
              <td>{{ date.date }}</td>
              <td>
                <button type="button" @click="deleteDate(date)" class="btn btn-danger">
                  <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {datepicker} from 'vue-strap';
  import configure from '../../configure';
  import {
    getConfigChampionship,
    getConfigDates
  } from '../../vuex/getters'
  import * as actions from '../../vuex/actions'

  export default {
    vuex: {
      getters: {
        championship: getConfigChampionship,
        dates: getConfigDates
      },
      actions: actions
    },
    components: {datepicker},
    data() {
      return {
        id: null,
        date: {id: null, date: '', championship_id: null},
      }
    },
    methods: {
      addDate() {
        let dates = this.dates;
        this.setLoading(true);
        this.date.championship_id = this.championship.id;
        this.$http.post(
          configure.api_url + 'dates',
          this.date
        ).then((response) => {
          dates.push(response.data);
          this.setConfigDates(dates);
          this.date = {id: null, date: '', championship_id: null};
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          alert('Error al guardar fecha');
        });
      },
      deleteDate(date) {
        let dates = this.dates;
        this.setLoading(true);
        this.$http.delete(
          configure.api_url + 'dates/' + date.id
        ).then((response) => {
          dates.$remove(date);
          this.setConfigDates(dates);
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message: 'Esta fecha tiene tarjetas ingresadas'})
        });
      }
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Dates.vue?7f2d6cb7
 **/